module.exports = {"360731100":"贡江镇","360731101":"铁山垅镇","360731102":"盘古山镇","360731103":"禾丰镇","360731104":"祁禄山镇","360731105":"梓山镇","360731106":"银坑镇","360731107":"岭背镇","360731108":"罗坳镇","360731200":"罗江乡","360731201":"小溪乡","360731202":"利村乡","360731203":"新陂乡","360731204":"靖石乡","360731205":"黄麟乡","360731206":"沙心乡","360731207":"宽田乡","360731208":"葛坳乡","360731209":"桥头乡","360731210":"马安乡","360731211":"仙下乡","360731212":"车溪乡","360731213":"段屋乡","360731400":"于都工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360731.json
// module id = 1411
// module chunks = 0